import { render, staticRenderFns } from "./PriceMaharaja.vue?vue&type=template&id=097deaba&scoped=true"
import script from "./PriceMaharaja.vue?vue&type=script&lang=js"
export * from "./PriceMaharaja.vue?vue&type=script&lang=js"
import style0 from "./PriceMaharaja.vue?vue&type=style&index=0&id=097deaba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "097deaba",
  null
  
)

export default component.exports